enum STORAGE_KEY {
  USER = 'user',
  TOKEN = 'token',
  CURRENT_PAGE = 'currentPage',
  EXPANDED_ITEMS = 'expandedItems',
  PROJECT_ID = 'projectId',
}

class LocalStorageService {
  setItem(key: STORAGE_KEY, data: string): void {
    localStorage.setItem(key, data);
  }

  getItem(key: STORAGE_KEY): string | null {
    return localStorage.getItem(key);
  }

  removeItem(key: STORAGE_KEY): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}

const localStorageService = new LocalStorageService();

export { STORAGE_KEY, localStorageService };
